
export default {
    name: 'AddressAdd',
    props: {
        /**
         * An address object
         */
        address: {
            type: Object,
            default() {
                return null;
            },
        },
        /**
         * A form object
         */
        form: {
            type: Object,
            required: true,
        },
    },
};
